import axios from "axios";
import { workerActions } from "../../slices/workers";
import { warehouseActions } from "../../slices/warehouse";

export const getQRCodeId = "qrFetch";
export const QRData = "QR";

export const getQRCode = ({ server, cloner_key, user }) => {
  const id = getQRCodeId;

  return async (dispatch) => {
    try {
      dispatch(workerActions.start(id));
      const url = server + "api/me";
      const response = await axios.get(url, {
        headers: { cloner_key },
        params: { user },
      });
      const keyTFA = response.data.user.key_tfa;
      const url2 = server + "api/user/qr-tfa";
      const qr = await axios.get(url2, {
        headers: { cloner_key },
        params: { keyTFA, user },
      });

      const { resp, Qr } = qr.data;

      if (resp === 0) {
        dispatch(warehouseActions.load({ id: QRData, data: Qr }));
        dispatch(workerActions.finish({ id }));
      }
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};
